import withIcon from './NewIcon';
// @ts-ignore
import IconTikTok from './icon/l/tiktok.s.svg';

export default withIcon(IconTikTok);
